// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__mDctD","overlay_body":"modal_overlay_body__YKx2d","close_icon":"modal_close_icon__vRH9M","animation_bg":"modal_animation_bg__Ey7mY"};